import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Titulo from './Titulo.jsx';
import Filtro from './Filtro.jsx';
import Table from './Table.jsx';
import Productos from './Productos.jsx';
import { GenericErrorScreen } from 'com-gyf-webcore-userinterfacecomponents';

class ListadoParametros extends Component {
    constructor(props) {
        super(props);
        this._dispatchToken = undefined;
    }

    componentDidMount() {
        let executionContext = this.props.executionContext;
        executionContext.UserId = executionContext?.UserId ? executionContext.UserId : this.props.currentScope.UserId;

        this.props.getDataListadoParametros(executionContext);
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {

        let componente = null;
        let spinner = <div className="loading"> Loading &#8230;</div>;

        if (this.props.atlas && this.props.atlas.rutearVistaInstancia) {
            return <Redirect push to={this.props.atlas.rutaVistaInstancia + "/" + this.props.atlas.entidadId} />;
        }

        if (this.props.data) {
            if (this.props.data?.functions && this.props.data?.functions?.Consulta == true) {
                componente = (
                    <div className="container-fluid atlas">
                        {this.props.data.loading
                            && spinner}
                        <Titulo />
                        <Filtro data={this.props.data}
                            findEntidades={this.props.findEntidades} />
                        <Productos data={this.props.data}
                            selectComboProducto={this.props.selectComboProducto} />
                        <Table 
                            icon={this.props.icon} 
                            data={this.props.data}
                            atlas={this.props.atlas}
                            orderColumn={this.props.orderColumn}
                            setearEntidad={this.props.setearEntidad} />
                    </div>
                );
            } else {
                let values = {
                    message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                    linkMessage: "Volver a mi pagina de inicio"
                };

                componente = (
                    <div>
                        {
                            this.props.data.isFetching ? spinner : <GenericErrorScreen data={values} />
                        }
                    </div>
                );
            }
            return (componente);
        }
        else {
            return (componente);
        }
    }
}
export default ListadoParametros;